import { LANGUAGE } from "@/common/utils/constants.js";

export const LOGIN_PAGE = {
	[LANGUAGE.en.short]: {
		login: {
			loginFailedSSO: "Login failed.",
			loginFailed: "Login failed. Incorrect email or password.",
			email: "Email",
			emailRequired: "The email is required.",
			emailInvalid: "Not a valid email address",
			password: "Password",
			passwordRequired: "Password is required",
			messageLogin: "Welcome to",
			haveCorporateAccount: "Have a corporate account?",
			signInFromHere: " Sign in from here",
			errorEmail: "The email is not in valid format.",
			errorPassword: "The password is required.",
			AddecoHint: "*to sign in as Adecco & associated Akkodis domain users",
			AkkaHint: "*to sign in as AKKA & associated Akkodis domain users",
			continueAddeco: "Continue with your Adecco account",
			continueAkka: "Continue with your Akka account"
		},
		email: "Email",
		password: "Password"
	},
	[LANGUAGE.de.short]: {
		login: {
			messageLogin: "Willkommen zu",
			haveCorporateAccount: "Haben Sie ein firmenkonto?",
			emailRequired: "Die E-Mail ist erforderlich.",
			signInFromHere: " Melden Sie sich von hier aus an",
			errorEmail: "Die E-Mail hat kein gültiges format.",
			errorPassword: "Das Passwort ist erforderlich.",
			AddecoHint: "*um sich als Adecco- und verbundene Akkodis-Domänenbenutzer anzumelden",
			AkkaHint: "*um sich als AKKA- und zugehörige Akkodis-Domänenbenutzer anzumelden",
			continueAddeco: "Fahren Sie mit Ihrem Adecco-Konto fort",
			continueAkka: "Fahren Sie mit Ihrem Akka-Konto fort"
		},
		email: "Email",
		password: "Passwort"
	},
	[LANGUAGE.fr.short]: {
		login: {
			messageLogin: "Bienvenue à",
			haveCorporateAccount: "Vous avez un compte d'entreprise?",
			emailRequired: "L'e-mail est obligatoire.",
			signInFromHere: " Connectez-vous ici",
			errorEmail: "L'e-mail n'est pas dans un format valide.",
			errorPassword: "Le mot de passe est requis.",
			AddecoHint: "*pour vous connecter en tant qu'utilisateurs de domaine Adecco et Akkodis associés",
			AkkaHint: "*pour vous connecter en tant qu'utilisateurs du domaine AKKA et Akkodis associés",
			continueAddeco: "Continuez avec votre compte Adecco",
			continueAkka: "Continuez avec votre compte Akka"
		},
		input: {
			email: "E-mail",
			password: "Mot de passe"
		},
	},
	[LANGUAGE.it.short]: {
		login: {
			messageLogin: "Benvenuto a",
			haveCorporateAccount: "Hai un account aziendale?",
			emailRequired: "L'e-mail è richiesta.",
			signInFromHere: " Accedi da qui",
			errorEmail: "L'e-mail non è in formato valido.",
			errorPassword: "La password è richiesta.",
			AddecoHint: "*per accedere come Adecco e utenti del dominio Akkodis associati",
			AkkaHint: "*per accedere come AKKA e utenti di dominio Akkodis associati",
			continueAddeco: "Continua con il tuo account Adecco",
			continueAkka: "Continua con il tuo account Akka"
		},
		input: {
			email: "E-mail",
			password: "Parola d'ordine"
		},
	},
	[LANGUAGE.ja.short]: {
		login: {
			messageLogin: "ようこそ",
			haveCorporateAccount: "企業アカウントをお持ちですか？",
			emailRequired: "メールが必要です。",
			signInFromHere: " ここからサインイン",
			errorEmail: "電子メールは有効な形式ではありません。",
			errorPassword: "パスワードが必要です。",
			AddecoHint: "*Adecco および関連する Akkodis ドメイン ユーザーとしてサインインするには",
			AkkaHint: "*AKKA および関連する Akkodis ドメイン ユーザーとしてサインインするには",
			continueAddeco: "アデコ アカウントで続行する",
			continueAkka: "Akka アカウントで続行する"
		},
		input: {
			email: "Eメール",
			password: "パスワード"
		},
	},
	[LANGUAGE.es.short]: {
		login: {
			messageLogin: "Bienvenido a",
			haveCorporateAccount: "¿Tiene una cuenta corporativa?",
			emailRequired: "El correo electrónico es obligatorio.",
			signInFromHere: " Inicia sesión desde aquí",
			errorEmail: "El correo electrónico no está en un formato válido.",
			errorPassword: "Se requiere contraseña.",
			AddecoHint: "*para iniciar sesión como usuarios de dominio Adecco y Akkodis asociados",
			AkkaHint: "*para iniciar sesión como usuarios de dominio AKKA y Akkodis asociados",
			continueAddeco: "Continuar con tu cuenta Adecco",
			continueAkka: "Continuar con tu cuenta Akka"
		},
		input: {
			email: "Correo electrónico",
			password: "Contraseña"
		},
	}
}
